import { makeStyles } from 'tss-react/mui-compat';

const useStyles = makeStyles()((theme) => ({
  maxWidthXs: {
    maxWidth: theme.breakpoints.values.xs,
  },
  maxWidthSm: {
    maxWidth: theme.breakpoints.values.sm,
  },
  maxWidthMd: {
    maxWidth: theme.breakpoints.values.md,
  },
  maxWidthLg: {
    maxWidth: theme.breakpoints.values.lg,
  },
  maxWidthXl: {
    maxWidth: theme.breakpoints.values.xl,
  },
}));

export type MaxWidthSteps = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * If the max width is given, returns a class name that restricts the width to the given max.
 *
 * @example
 * const maxWidth = useMaxWidth(props.maxWidth);
 *
 * return (
 *   <div className={clsx(classes.root, maxWidth)}>
 *     ...
 *   </div>
 * );
 *
 * @param maxWidth
 */
export function useMaxWidth(maxWidth: MaxWidthSteps | undefined): string | undefined {
  const { classes } = useStyles();
  switch (maxWidth) {
    case 'xs':
      return classes.maxWidthXs;
    case 'sm':
      return classes.maxWidthSm;
    case 'md':
      return classes.maxWidthMd;
    case 'lg':
      return classes.maxWidthLg;
    case 'xl':
      return classes.maxWidthXl;
    default:
      return undefined;
  }
}
